import React from "react";
import { iconProps } from "../Helper";

const UnarchieveIcon = ({className}:iconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        d="M9 7.2885L5.34625 10.9423L6.4 11.996L8.25 10.146V14.596H9.75V10.146L11.6 11.996L12.6538 10.9423L9 7.2885ZM2 4.90375V15.6923C2 15.7821 2.02883 15.8558 2.0865 15.9135C2.14417 15.9712 2.21792 16 2.30775 16H15.6923C15.7821 16 15.8558 15.9712 15.9135 15.9135C15.9712 15.8558 16 15.7821 16 15.6923V4.90375H2ZM2.38475 17.5C1.88592 17.5 1.44708 17.3106 1.06825 16.9318C0.689417 16.5529 0.5 16.1141 0.5 15.6152V4.00575C0.5 3.79175 0.534333 3.58758 0.603 3.39325C0.6715 3.19908 0.774334 3.01992 0.9115 2.85575L2.3155 1.15775C2.4795 0.943583 2.68458 0.780416 2.93075 0.66825C3.17692 0.556083 3.43717 0.5 3.7115 0.5H14.2693C14.5436 0.5 14.8054 0.556083 15.0548 0.66825C15.3041 0.780416 15.5108 0.943583 15.675 1.15775L17.0885 2.875C17.2257 3.03917 17.3285 3.21992 17.397 3.41725C17.4657 3.61475 17.5 3.82058 17.5 4.03475V15.6152C17.5 16.1141 17.3106 16.5529 16.9318 16.9318C16.5529 17.3106 16.1141 17.5 15.6152 17.5H2.38475ZM2.3905 3.404H15.6L14.5095 2.10575C14.4775 2.07375 14.4407 2.04808 14.399 2.02875C14.3573 2.00958 14.3141 2 14.2693 2H3.72125C3.67642 2 3.63308 2.00958 3.59125 2.02875C3.54958 2.04808 3.51275 2.07375 3.48075 2.10575L2.3905 3.404Z"
        fill="white"
      />
    </svg>
  );
};

export default UnarchieveIcon;